/**
 * Flow Chair GRASSIMESSE landing page behaviour.
 * Countdown, swatch selection, checkout permalinks, analytics.
 */
(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function getUtmParams() {
    var params = new URLSearchParams(window.location.search);
    var out = new URLSearchParams();
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (key) {
      var value = params.get(key);
      if (value) out.set(key, value);
    });
    return out;
  }

  function buildCheckoutHref(variant, discountCode, offerActive, applyDiscount) {
    if (!variant) return '#';

    var attr = (document.querySelector('[data-mfc-root]') || {}).dataset;
    var quelle = (attr && attr.cartAttribute) || 'GRASSIMESSE-2026';
    var href = '/cart/' + variant.id + ':1?attributes[Quelle]=' + encodeURIComponent(quelle);

    if (applyDiscount && offerActive && discountCode) {
      href = '/cart/' + variant.id + ':1?discount=' + encodeURIComponent(discountCode) +
        '&attributes[Quelle]=' + encodeURIComponent(quelle);
    }

    var utm = getUtmParams().toString();
    if (utm) href += '&' + utm;
    return href;
  }

  function formatCountdown(diffMs) {
    var diff = Math.max(0, diffMs);
    var d = Math.floor(diff / 86400000);
    diff -= d * 86400000;
    var h = Math.floor(diff / 3600000);
    diff -= h * 3600000;
    var m = Math.floor(diff / 60000);
    diff -= m * 60000;
    var s = Math.floor(diff / 1000);
    return {
      full: d + 'T ' + pad(h) + ':' + pad(m) + ':' + pad(s),
      short: d + ' Tage ' + h + ' Std',
      expired: diffMs <= 0
    };
  }

  function fireViewItem(payload) {
    if (typeof gtag !== 'function' || !payload) return;
    gtag('event', 'view_item', {
      currency: payload.currency || 'EUR',
      value: payload.price,
      items: [{
        item_id: String(payload.variantId),
        item_name: payload.title || 'Flow Chair',
        item_variant: payload.colorName,
        price: payload.price,
        quantity: 1
      }]
    });
  }

  function fireBeginCheckout(payload) {
    if (typeof gtag !== 'function' || !payload) return;
    gtag('event', 'begin_checkout', {
      currency: payload.currency || 'EUR',
      value: payload.price,
      coupon: payload.discountCode || undefined,
      items: [{
        item_id: String(payload.variantId),
        item_name: payload.title || 'Flow Chair',
        item_variant: payload.colorName,
        price: payload.price,
        quantity: 1
      }]
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.mfcReady === 'true') return;
    root.dataset.mfcReady = 'true';

    var deadlineIso = root.dataset.deadlineIso;
    var discountCode = root.dataset.discountCode || '';
    var discountCents = Math.round(Number(root.dataset.discountAmount || 0) * 100);
    var applyDiscount = root.dataset.applyDiscount === 'true';
    var cartAttribute = root.dataset.cartAttribute || 'GRASSIMESSE-2026';
    var currency = root.dataset.currency || 'EUR';
    var productTitle = root.dataset.productTitle || 'Flow Chair';
    var productUrl = root.dataset.productUrl || '/';

    var variants = [];
    try {
      var variantsNode = root.querySelector('[data-mfc-variants]');
      variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]');
    } catch (e) {
      variants = [];
    }

    var countdownEls = document.querySelectorAll('[data-mfc-countdown]');
    var countdownShortEls = document.querySelectorAll('[data-mfc-countdown-short]');
    var colorNameEls = root.querySelectorAll('[data-mfc-color-name]');
    var orderLinks = document.querySelectorAll('[data-mfc-order]');
    var offerPriceEls = document.querySelectorAll('[data-mfc-offer-price]');
    var regularPriceEls = document.querySelectorAll('[data-mfc-regular-price]');
    var finalTitles = document.querySelectorAll('[data-mfc-final-title]');
    var swatches = root.querySelectorAll('[data-mfc-swatch]');
    var thumbs = root.querySelectorAll('[data-mfc-hero-thumb]');

    var selected = variants.find(function (v) { return v.default; }) ||
      variants.find(function (v) { return v.available; }) ||
      variants[0];

    function euros(cents) {
      return Math.round(Number(cents) / 100) + ' €';
    }

    function offerActive() {
      if (!deadlineIso) return true;
      return Date.now() < new Date(deadlineIso).getTime();
    }

    function displayPrice(variant) {
      var price = Number(variant.price);
      var compare = Number(variant.compareAtPrice || 0);
      if (applyDiscount && offerActive() && discountCents > 0) {
        if (compare < price) compare = price;
        price = Math.max(0, price - discountCents);
      }
      var showCompare = compare > price;
      return {
        offer: euros(price),
        regular: showCompare ? euros(compare) : '',
        numeric: price / 100,
        showCompare: showCompare,
        savings: showCompare ? Math.round((compare - price) / 100) : 0
      };
    }

    function updateHeroImage(variant) {
      var heroImg = root.querySelector('.mfc-hero-img');
      if (!heroImg || !variant || !variant.imageSrc) return;
      if (heroImg.getAttribute('src') === variant.imageSrc) return;

      heroImg.classList.add('is-switching');
      var swap = function () {
        heroImg.setAttribute('src', variant.imageSrc);
        if (variant.imageSrcset) {
          heroImg.setAttribute('srcset', variant.imageSrcset);
        } else {
          heroImg.removeAttribute('srcset');
        }
        if (variant.imageAlt) {
          heroImg.setAttribute('alt', variant.imageAlt);
        }
        // Clear focal-point override from a previous upload so new crops read cleanly
        heroImg.style.removeProperty('object-position');
        heroImg.classList.remove('is-switching');
      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        swap();
        return;
      }

      window.setTimeout(swap, 120);
    }

    function updateLinks() {
      if (!selected) return;
      var href = buildCheckoutHref(selected, discountCode, offerActive(), applyDiscount);
      orderLinks.forEach(function (el) {
        el.setAttribute('href', href);
      });
      root.dataset.productUrl = selected.productUrl || productUrl || '/';
      colorNameEls.forEach(function (el) {
        el.textContent = selected.name;
      });
      var prices = displayPrice(selected);
      offerPriceEls.forEach(function (el) {
        el.textContent = prices.offer;
      });
      regularPriceEls.forEach(function (el) {
        el.textContent = prices.regular;
        if (prices.showCompare) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
      root.querySelectorAll('[data-mfc-price-badge]').forEach(function (el) {
        if (prices.showCompare && prices.savings > 0) {
          el.textContent = '-' + prices.savings + ' €';
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });

      var heroCtaLabels = root.querySelectorAll('[data-mfc-hero-cta-label]');
      heroCtaLabels.forEach(function (el) {
        var template = el.getAttribute('data-label-template') || el.textContent;
        if (!el.getAttribute('data-label-template')) {
          el.setAttribute('data-label-template', template);
        }
        el.textContent = el.getAttribute('data-label-template').replace('[price]', prices.offer);
      });

      finalTitles.forEach(function (el) {
        var template = el.getAttribute('data-title-template') || el.textContent;
        if (!el.getAttribute('data-title-template')) {
          el.setAttribute('data-title-template', template);
        }
        var headingTemplate = el.getAttribute('data-title-template');
        el.textContent = headingTemplate
          .replace('[price]', prices.offer)
          .replace(/\s*Für\s*\.\s*/g, ' ')
          .replace(/\s{2,}/g, ' ')
          .trim();
      });

      updateHeroImage(selected);
    }

    // Prefetch other color hero images so swatch switches feel instant
    variants.forEach(function (variant) {
      if (!variant.imageSrc) return;
      var preload = new Image();
      preload.src = variant.imageSrc;
    });

    function selectVariant(variantId) {
      var next = variants.find(function (v) { return String(v.id) === String(variantId); });
      if (!next || !next.available) return;
      selected = next;
      swatches.forEach(function (btn) {
        var pressed = String(btn.dataset.variantId) === String(variantId);
        btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      });
      thumbs.forEach(function (btn) {
        var pressed = String(btn.dataset.variantId) === String(variantId);
        btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      });
      updateLinks();
    }

    function availableVariants() {
      return variants.filter(function (v) { return v.available; });
    }

    function stepVariant(direction) {
      var list = availableVariants();
      if (!list.length) return;
      var currentId = selected ? String(selected.id) : '';
      var index = list.findIndex(function (v) { return String(v.id) === currentId; });
      if (index < 0) index = 0;
      var nextIndex = (index + direction + list.length) % list.length;
      selectVariant(list[nextIndex].id);
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectVariant(btn.dataset.variantId);
      });
    });

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectVariant(btn.dataset.variantId);
      });
    });

    var prevBtn = root.querySelector('[data-mfc-hero-prev]');
    var nextBtn = root.querySelector('[data-mfc-hero-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stepVariant(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stepVariant(1);
      });
    }

    orderLinks.forEach(function (el) {
      el.addEventListener('click', function () {
        if (!selected) return;
        var prices = displayPrice(selected);
        fireBeginCheckout({
          variantId: selected.id,
          title: productTitle,
          colorName: selected.name,
          price: prices.numeric,
          currency: currency,
          discountCode: applyDiscount && offerActive() ? discountCode : ''
        });
      });
    });

    function tick() {
      var deadline = deadlineIso ? new Date(deadlineIso).getTime() : 0;
      var result = formatCountdown(deadline - Date.now());
      countdownEls.forEach(function (el) {
        el.textContent = result.full;
      });
      countdownShortEls.forEach(function (el) {
        el.textContent = result.short;
      });

      if (result.expired) {
        root.classList.add('is-expired');
        updateLinks();
      } else {
        root.classList.remove('is-expired');
      }
    }

    tick();
    updateLinks();
    setInterval(tick, 1000);

    if (selected) {
      var prices = displayPrice(selected);
      fireViewItem({
        variantId: selected.id,
        title: productTitle,
        colorName: selected.name,
        price: prices.numeric,
        currency: currency
      });
    }

    // Sticky bar only after hero CTA leaves the viewport
    var heroCta = root.querySelector('[data-mfc-hero-cta]');
    var sticky = root.querySelector('.mfc-sticky');
    if (heroCta && sticky && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.remove('is-sticky-active');
            } else {
              // Only show after scrolling past the button (not above the page top)
              if (entry.boundingClientRect.top < 0) {
                root.classList.add('is-sticky-active');
              } else {
                root.classList.remove('is-sticky-active');
              }
            }
          });
        },
        { threshold: 0, rootMargin: '0px' }
      );
      stickyObserver.observe(heroCta);
    } else if (sticky) {
      root.classList.add('is-sticky-active');
    }

    // Keep form success in view
    if (root.querySelector('[data-mfc-form-success]')) {
      var formBox = root.querySelector('#mfc-capture');
      if (formBox) {
        formBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  function initUniqueLightbox(sectionRoot) {
    var gallery = sectionRoot.querySelector('[data-mfc-unique-gallery]');
    var dialog = sectionRoot.querySelector('[data-mfc-unique-lightbox]');
    if (!gallery || !dialog || dialog.dataset.mfcUniqueReady === 'true') return;

    var slides = Array.prototype.slice.call(dialog.querySelectorAll('[data-mfc-unique-slide]'));
    if (!slides.length) return;

    var openButtons = Array.prototype.slice.call(gallery.querySelectorAll('[data-mfc-unique-open]'));
    var closeBtn = dialog.querySelector('[data-mfc-unique-close]');
    var prevBtn = dialog.querySelector('[data-mfc-unique-prev]');
    var nextBtn = dialog.querySelector('[data-mfc-unique-next]');
    var counter = dialog.querySelector('[data-mfc-unique-counter]');
    var stage = dialog.querySelector('[data-mfc-unique-stage]');
    var index = 0;
    var touchStartX = 0;
    var touchDeltaX = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      if (counter) {
        if (slides.length > 1) {
          counter.hidden = false;
          counter.textContent = (index + 1) + ' / ' + slides.length;
        } else {
          counter.hidden = true;
        }
      }
      if (prevBtn) prevBtn.hidden = slides.length < 2;
      if (nextBtn) nextBtn.hidden = slides.length < 2;
    }

    function openAt(i) {
      show(i);
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function closeLightbox() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var start = parseInt(btn.getAttribute('data-index'), 10);
        openAt(isNaN(start) ? 0 : start);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeLightbox();
    });

    dialog.addEventListener('keydown', function (event) {
      if (!dialog.open) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
      }
    });

    if (stage) {
      stage.addEventListener('touchstart', function (event) {
        if (!event.changedTouches || !event.changedTouches.length) return;
        touchStartX = event.changedTouches[0].clientX;
        touchDeltaX = 0;
      }, { passive: true });

      stage.addEventListener('touchmove', function (event) {
        if (!event.changedTouches || !event.changedTouches.length) return;
        touchDeltaX = event.changedTouches[0].clientX - touchStartX;
      }, { passive: true });

      stage.addEventListener('touchend', function () {
        if (Math.abs(touchDeltaX) < 40 || slides.length < 2) return;
        if (touchDeltaX < 0) show(index + 1);
        else show(index - 1);
        touchDeltaX = 0;
      });
    }

    dialog.dataset.mfcUniqueReady = 'true';
  }

  function boot() {
    document.querySelectorAll('[data-mfc-root]').forEach(initRoot);
    document.querySelectorAll('.shopify-section.section-flow-unique').forEach(initUniqueLightbox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
